const billingTranslations = {
  en: {
    signInTitle: "Sign in to upgrade",
    signInDescription: "Log in to compare plans and continue your secure checkout.",
    signInButton: "Sign in to continue",
    title: "Premium skipper plan",
    subtitle: "Turn free tools into a daily departure workflow",
    currentPlan: "Current Plan",
    currentPlanDescription: "Your subscription status and details",
    currentTier: "Current Tier",
    billingCycle: "Billing Cycle",
    status: "Status",
    renewsOn: "Renews On",
    notAvailable: "N/A",
    readyForMore: "Ready for better departure decisions?",
    upgradeToPlanForFeatures: "Upgrade to {plan} for advanced features",
    upgradeTo: "Upgrade to {plan}",
    plansTab: "📋 Plans",
    historyTab: "💰 Billing History",
    paymentTab: "🔐 Payment Method",
    billingHistory: "Billing History",
    transactions: "{count} transactions",
    noHistory: "No billing history yet",
    paymentMethod: "Payment Method",
    updateBillingInfo: "Update your billing information",
    provider: "Provider",
    paypalAvailable: "PayPal available",
    subscriptionId: "Subscription ID",
    updatePaymentMethod: "Update Payment Method",
    viewInvoices: "View Invoices",
    cancelPrompt: "Want to pause or cancel your subscription?",
    cancelSubscription: "Cancel Subscription",
    faqTitle: "❓ Billing FAQ",
    faqPlanQ: "Can I change my plan anytime?",
    faqPlanA: "Yes, you can upgrade or downgrade at any time. Changes take effect immediately.",
    faqRefundQ: "Do you offer refunds?",
    faqRefundA: "Refund eligibility depends on your account and payment provider. Contact support for details.",
    faqFailQ: "What if my payment fails?",
    faqFailA: "We'll notify you and retry automatically. Update your payment method to avoid interruptions.",
    pricing: {
      empty: "Subscription plans are not available yet.",
      label: "Pricing",
      title: "Choose the plan that fits your sailing decisions",
      description: "Compare free discovery with premium skipper decision support: personalized briefings, saved-area intelligence, and route risk awareness.",
      secure: "Secure checkout is available on every upgrade option.",
      bestValue: "Best value",
      current: "Current",
      perMonth: "/ month",
      yearly: "Yearly: ${price}",
      included: "Included features",
      currentPlanNote: "You are on this plan",
      compareTitle: "Compare features",
      compareDescription: "See what each tier includes before choosing your upgrade.",
      feature: "Feature"
    },
    paypal: {
      title: "Pay with PayPal",
      description: "Secure checkout using your PayPal account or card.",
      recommended: "Recommended",
      selectedPlan: "Selected plan",
      continue: "Continue with PayPal",
      secure: "Payments are handled securely by PayPal."
    },
    receipt: {
      button: "Receipt PDF",
      title: "Payment Receipt",
      receiptId: "Receipt ID",
      date: "Date",
      member: "Member",
      memberFallback: "Member",
      tier: "Subscription tier",
      cycle: "Billing cycle",
      type: "Transaction type",
      provider: "Provider",
      status: "Status",
      total: "Total paid",
      thanks: "Thank you for your subscription."
    }
  },
  he: {
    signInTitle: "התחבר כדי לשדרג",
    signInDescription: "התחבר כדי לראות תוכניות ולהמשיך לתשלום מאובטח ב-PayPal.",
    signInButton: "התחבר להמשך",
    title: "💳 חיוב ותוכנית",
    subtitle: "ניהול המנוי ואמצעי התשלום שלך",
    currentPlan: "התוכנית הנוכחית",
    currentPlanDescription: "סטטוס המנוי והפרטים שלך",
    currentTier: "רמת תוכנית",
    billingCycle: "מחזור חיוב",
    status: "סטטוס",
    renewsOn: "מתחדש בתאריך",
    notAvailable: "לא זמין",
    readyForMore: "מוכן ליותר יכולות?",
    upgradeToPlanForFeatures: "שדרג ל-{plan} עבור יכולות מתקדמות",
    upgradeTo: "שדרג ל-{plan}",
    plansTab: "📋 תוכניות",
    historyTab: "💰 היסטוריית חיובים",
    paymentTab: "🔐 אמצעי תשלום",
    billingHistory: "היסטוריית חיובים",
    transactions: "{count} עסקאות",
    noHistory: "אין עדיין היסטוריית חיובים",
    paymentMethod: "אמצעי תשלום",
    updateBillingInfo: "עדכן את פרטי החיוב שלך",
    provider: "ספק",
    paypalAvailable: "PayPal זמין",
    subscriptionId: "מזהה מנוי",
    updatePaymentMethod: "עדכן אמצעי תשלום",
    viewInvoices: "צפה בחשבוניות",
    cancelPrompt: "רוצה להשהות או לבטל את המנוי?",
    cancelSubscription: "בטל מנוי",
    faqTitle: "❓ שאלות נפוצות על חיובים",
    faqPlanQ: "אפשר לשנות תוכנית בכל זמן?",
    faqPlanA: "כן, אפשר לשדרג או לשנמך בכל עת. השינויים נכנסים לתוקף מיד.",
    faqRefundQ: "האם אתם מציעים החזרים?",
    faqRefundA: "זכאות להחזר תלויה בחשבון שלך ובספק התשלום. לפרטים פנה לתמיכה.",
    faqFailQ: "מה קורה אם התשלום נכשל?",
    faqFailA: "נודיע לך וננסה שוב אוטומטית. עדכן את אמצעי התשלום כדי למנוע הפרעות.",
    pricing: {
      empty: "תוכניות המנוי עדיין אינן זמינות.",
      label: "תמחור",
      title: "בחר את התוכנית שמתאימה לשיטת ההפלגה שלך",
      description: "השווה תוכניות, בדוק יכולות כלולות, ואז שדרג בבטחה עם PayPal כשתהיה מוכן.",
      secure: "תשלום מאובטח ב-PayPal זמין בכל אפשרות שדרוג.",
      bestValue: "המשתלם ביותר",
      current: "נוכחי",
      perMonth: "/ חודש",
      yearly: "שנתי: ${price}",
      included: "יכולות כלולות",
      currentPlanNote: "אתה נמצא בתוכנית זו",
      compareTitle: "השוואת יכולות",
      compareDescription: "ראה מה כל רמה כוללת לפני בחירת השדרוג.",
      feature: "יכולת"
    },
    paypal: {
      title: "תשלום עם PayPal",
      description: "תשלום מאובטח באמצעות חשבון PayPal או כרטיס.",
      recommended: "מומלץ",
      selectedPlan: "תוכנית נבחרת",
      continue: "המשך עם PayPal",
      secure: "התשלומים מנוהלים בצורה מאובטחת על ידי PayPal."
    },
    receipt: {
      button: "קבלת PDF",
      title: "קבלת תשלום",
      receiptId: "מזהה קבלה",
      date: "תאריך",
      member: "חבר",
      memberFallback: "חבר",
      tier: "רמת מנוי",
      cycle: "מחזור חיוב",
      type: "סוג עסקה",
      provider: "ספק",
      status: "סטטוס",
      total: "סה״כ שולם",
      thanks: "תודה על המנוי שלך."
    }
  },
  es: {
    signInTitle: "Inicia sesión para actualizar",
    signInDescription: "Inicia sesión para ver planes y continuar al pago con PayPal.",
    signInButton: "Iniciar sesión para continuar",
    title: "💳 Facturación y plan",
    subtitle: "Gestiona tu suscripción y método de pago",
    currentPlan: "Plan actual",
    currentPlanDescription: "Estado y detalles de tu suscripción",
    currentTier: "Nivel actual",
    billingCycle: "Ciclo de facturación",
    status: "Estado",
    renewsOn: "Renueva el",
    notAvailable: "N/D",
    readyForMore: "¿Listo para más potencia?",
    upgradeToPlanForFeatures: "Actualiza a {plan} para funciones avanzadas",
    upgradeTo: "Actualizar a {plan}",
    plansTab: "📋 Planes",
    historyTab: "💰 Historial",
    paymentTab: "🔐 Método de pago",
    billingHistory: "Historial de facturación",
    transactions: "{count} transacciones",
    noHistory: "Aún no hay historial de facturación",
    paymentMethod: "Método de pago",
    updateBillingInfo: "Actualiza tu información de facturación",
    provider: "Proveedor",
    paypalAvailable: "PayPal disponible",
    subscriptionId: "ID de suscripción",
    updatePaymentMethod: "Actualizar método de pago",
    viewInvoices: "Ver facturas",
    cancelPrompt: "¿Quieres pausar o cancelar tu suscripción?",
    cancelSubscription: "Cancelar suscripción",
    faqTitle: "❓ Preguntas de facturación",
    faqPlanQ: "¿Puedo cambiar mi plan en cualquier momento?",
    faqPlanA: "Sí, puedes subir o bajar de plan en cualquier momento. Los cambios se aplican de inmediato.",
    faqRefundQ: "¿Ofrecen reembolsos?",
    faqRefundA: "La elegibilidad de reembolso depende de tu cuenta y proveedor de pago. Contacta con soporte para más detalles.",
    faqFailQ: "¿Qué pasa si mi pago falla?",
    faqFailA: "Te avisaremos y lo reintentaremos automáticamente. Actualiza tu método de pago para evitar interrupciones.",
    pricing: {
      empty: "Los planes de suscripción aún no están disponibles.",
      label: "Precios",
      title: "Elige el plan que encaja con tu forma de navegar",
      description: "Compara niveles, revisa funciones incluidas y actualiza de forma segura con PayPal cuando estés listo.",
      secure: "Pago seguro con PayPal disponible en cada opción de actualización.",
      bestValue: "Mejor valor",
      current: "Actual",
      perMonth: "/ mes",
      yearly: "Anual: ${price}",
      included: "Funciones incluidas",
      currentPlanNote: "Estás en este plan",
      compareTitle: "Comparar funciones",
      compareDescription: "Mira qué incluye cada nivel antes de elegir tu actualización.",
      feature: "Función"
    },
    paypal: {
      title: "Pagar con PayPal",
      description: "Pago seguro con tu cuenta PayPal o tarjeta.",
      recommended: "Recomendado",
      selectedPlan: "Plan seleccionado",
      continue: "Continuar con PayPal",
      secure: "Los pagos son gestionados de forma segura por PayPal."
    },
    receipt: {
      button: "Recibo PDF",
      title: "Recibo de pago",
      receiptId: "ID de recibo",
      date: "Fecha",
      member: "Miembro",
      memberFallback: "Miembro",
      tier: "Nivel de suscripción",
      cycle: "Ciclo de facturación",
      type: "Tipo de transacción",
      provider: "Proveedor",
      status: "Estado",
      total: "Total pagado",
      thanks: "Gracias por tu suscripción."
    }
  },
  it: {
    signInTitle: "Accedi per fare l’upgrade",
    signInDescription: "Accedi per vedere i piani e continuare al pagamento PayPal.",
    signInButton: "Accedi per continuare",
    title: "💳 Fatturazione e piano",
    subtitle: "Gestisci abbonamento e metodo di pagamento",
    currentPlan: "Piano attuale",
    currentPlanDescription: "Stato e dettagli del tuo abbonamento",
    currentTier: "Livello attuale",
    billingCycle: "Ciclo di fatturazione",
    status: "Stato",
    renewsOn: "Rinnova il",
    notAvailable: "N/D",
    readyForMore: "Pronto per più potenza?",
    upgradeToPlanForFeatures: "Passa a {plan} per funzioni avanzate",
    upgradeTo: "Passa a {plan}",
    plansTab: "📋 Piani",
    historyTab: "💰 Cronologia pagamenti",
    paymentTab: "🔐 Metodo di pagamento",
    billingHistory: "Cronologia fatturazione",
    transactions: "{count} transazioni",
    noHistory: "Nessuna cronologia di fatturazione",
    paymentMethod: "Metodo di pagamento",
    updateBillingInfo: "Aggiorna i dati di fatturazione",
    provider: "Fornitore",
    paypalAvailable: "PayPal disponibile",
    subscriptionId: "ID abbonamento",
    updatePaymentMethod: "Aggiorna metodo di pagamento",
    viewInvoices: "Vedi fatture",
    cancelPrompt: "Vuoi sospendere o annullare l’abbonamento?",
    cancelSubscription: "Annulla abbonamento",
    faqTitle: "❓ FAQ fatturazione",
    faqPlanQ: "Posso cambiare piano in qualsiasi momento?",
    faqPlanA: "Sì, puoi fare upgrade o downgrade in qualsiasi momento. Le modifiche sono immediate.",
    faqRefundQ: "Offrite rimborsi?",
    faqRefundA: "L’idoneità al rimborso dipende dal tuo account e dal fornitore di pagamento. Contatta il supporto per i dettagli.",
    faqFailQ: "Cosa succede se il pagamento fallisce?",
    faqFailA: "Ti avviseremo e riproveremo automaticamente. Aggiorna il metodo di pagamento per evitare interruzioni.",
    pricing: {
      empty: "I piani di abbonamento non sono ancora disponibili.",
      label: "Prezzi",
      title: "Scegli il piano adatto al tuo modo di navigare",
      description: "Confronta i livelli, controlla le funzioni incluse e fai l’upgrade in sicurezza con PayPal quando sei pronto.",
      secure: "Checkout PayPal sicuro disponibile per ogni opzione di upgrade.",
      bestValue: "Miglior valore",
      current: "Attuale",
      perMonth: "/ mese",
      yearly: "Annuale: ${price}",
      included: "Funzioni incluse",
      currentPlanNote: "Stai usando questo piano",
      compareTitle: "Confronta funzioni",
      compareDescription: "Guarda cosa include ogni livello prima di scegliere l’upgrade.",
      feature: "Funzione"
    },
    paypal: {
      title: "Paga con PayPal",
      description: "Checkout sicuro con account PayPal o carta.",
      recommended: "Consigliato",
      selectedPlan: "Piano selezionato",
      continue: "Continua con PayPal",
      secure: "I pagamenti sono gestiti in modo sicuro da PayPal."
    },
    receipt: {
      button: "Ricevuta PDF",
      title: "Ricevuta di pagamento",
      receiptId: "ID ricevuta",
      date: "Data",
      member: "Membro",
      memberFallback: "Membro",
      tier: "Livello abbonamento",
      cycle: "Ciclo di fatturazione",
      type: "Tipo transazione",
      provider: "Fornitore",
      status: "Stato",
      total: "Totale pagato",
      thanks: "Grazie per il tuo abbonamento."
    }
  },
  fr: {
    signInTitle: "Connectez-vous pour passer à l’offre supérieure",
    signInDescription: "Connectez-vous pour voir les offres et continuer vers le paiement PayPal.",
    signInButton: "Se connecter pour continuer",
    title: "💳 Facturation et offre",
    subtitle: "Gérez votre abonnement et votre moyen de paiement",
    currentPlan: "Offre actuelle",
    currentPlanDescription: "Statut et détails de votre abonnement",
    currentTier: "Niveau actuel",
    billingCycle: "Cycle de facturation",
    status: "Statut",
    renewsOn: "Renouvellement le",
    notAvailable: "N/D",
    readyForMore: "Prêt pour plus de puissance ?",
    upgradeToPlanForFeatures: "Passez à {plan} pour des fonctions avancées",
    upgradeTo: "Passer à {plan}",
    plansTab: "📋 Offres",
    historyTab: "💰 Historique",
    paymentTab: "🔐 Paiement",
    billingHistory: "Historique de facturation",
    transactions: "{count} transactions",
    noHistory: "Aucun historique de facturation pour le moment",
    paymentMethod: "Moyen de paiement",
    updateBillingInfo: "Mettez à jour vos informations de facturation",
    provider: "Fournisseur",
    paypalAvailable: "PayPal disponible",
    subscriptionId: "ID d’abonnement",
    updatePaymentMethod: "Mettre à jour le moyen de paiement",
    viewInvoices: "Voir les factures",
    cancelPrompt: "Vous souhaitez suspendre ou annuler votre abonnement ?",
    cancelSubscription: "Annuler l’abonnement",
    faqTitle: "❓ FAQ facturation",
    faqPlanQ: "Puis-je changer d’offre à tout moment ?",
    faqPlanA: "Oui, vous pouvez monter ou descendre d’offre à tout moment. Les changements prennent effet immédiatement.",
    faqRefundQ: "Proposez-vous des remboursements ?",
    faqRefundA: "L’éligibilité au remboursement dépend de votre compte et du fournisseur de paiement. Contactez le support pour plus de détails.",
    faqFailQ: "Que se passe-t-il si mon paiement échoue ?",
    faqFailA: "Nous vous préviendrons et réessaierons automatiquement. Mettez à jour votre moyen de paiement pour éviter les interruptions.",
    pricing: {
      empty: "Les offres d’abonnement ne sont pas encore disponibles.",
      label: "Tarifs",
      title: "Choisissez l’offre adaptée à votre navigation",
      description: "Comparez les niveaux, vérifiez les fonctions incluses, puis passez à l’offre supérieure en toute sécurité avec PayPal.",
      secure: "Paiement PayPal sécurisé disponible sur chaque option d’upgrade.",
      bestValue: "Meilleur choix",
      current: "Actuelle",
      perMonth: "/ mois",
      yearly: "Annuel : ${price}",
      included: "Fonctions incluses",
      currentPlanNote: "Vous utilisez cette offre",
      compareTitle: "Comparer les fonctions",
      compareDescription: "Voyez ce que chaque niveau inclut avant de choisir votre upgrade.",
      feature: "Fonction"
    },
    paypal: {
      title: "Payer avec PayPal",
      description: "Paiement sécurisé avec votre compte PayPal ou carte.",
      recommended: "Recommandé",
      selectedPlan: "Offre sélectionnée",
      continue: "Continuer avec PayPal",
      secure: "Les paiements sont traités en toute sécurité par PayPal."
    },
    receipt: {
      button: "Reçu PDF",
      title: "Reçu de paiement",
      receiptId: "ID du reçu",
      date: "Date",
      member: "Membre",
      memberFallback: "Membre",
      tier: "Niveau d’abonnement",
      cycle: "Cycle de facturation",
      type: "Type de transaction",
      provider: "Fournisseur",
      status: "Statut",
      total: "Total payé",
      thanks: "Merci pour votre abonnement."
    }
  },
  de: {
    signInTitle: "Zum Upgrade anmelden",
    signInDescription: "Melde dich an, um Tarife anzusehen und mit PayPal fortzufahren.",
    signInButton: "Anmelden und fortfahren",
    title: "💳 Abrechnung & Tarif",
    subtitle: "Verwalte dein Abonnement und deine Zahlungsmethode",
    currentPlan: "Aktueller Tarif",
    currentPlanDescription: "Status und Details deines Abonnements",
    currentTier: "Aktuelle Stufe",
    billingCycle: "Abrechnungszyklus",
    status: "Status",
    renewsOn: "Verlängert sich am",
    notAvailable: "N/V",
    readyForMore: "Bereit für mehr Leistung?",
    upgradeToPlanForFeatures: "Upgrade auf {plan} für erweiterte Funktionen",
    upgradeTo: "Upgrade auf {plan}",
    plansTab: "📋 Tarife",
    historyTab: "💰 Verlauf",
    paymentTab: "🔐 Zahlungsmethode",
    billingHistory: "Abrechnungsverlauf",
    transactions: "{count} Transaktionen",
    noHistory: "Noch kein Abrechnungsverlauf",
    paymentMethod: "Zahlungsmethode",
    updateBillingInfo: "Aktualisiere deine Zahlungsdaten",
    provider: "Anbieter",
    paypalAvailable: "PayPal verfügbar",
    subscriptionId: "Abonnement-ID",
    updatePaymentMethod: "Zahlungsmethode aktualisieren",
    viewInvoices: "Rechnungen anzeigen",
    cancelPrompt: "Möchtest du dein Abonnement pausieren oder kündigen?",
    cancelSubscription: "Abonnement kündigen",
    faqTitle: "❓ Abrechnungs-FAQ",
    faqPlanQ: "Kann ich meinen Tarif jederzeit ändern?",
    faqPlanA: "Ja, du kannst jederzeit upgraden oder downgraden. Änderungen gelten sofort.",
    faqRefundQ: "Bietet ihr Rückerstattungen an?",
    faqRefundA: "Die Erstattungsberechtigung hängt von deinem Konto und Zahlungsanbieter ab. Kontaktiere den Support für Details.",
    faqFailQ: "Was passiert, wenn meine Zahlung fehlschlägt?",
    faqFailA: "Wir benachrichtigen dich und versuchen es automatisch erneut. Aktualisiere deine Zahlungsmethode, um Unterbrechungen zu vermeiden.",
    pricing: {
      empty: "Abonnementtarife sind noch nicht verfügbar.",
      label: "Preise",
      title: "Wähle den Tarif, der zu deinem Segel-Workflow passt",
      description: "Vergleiche Tarifstufen, prüfe enthaltene Funktionen und upgrade sicher mit PayPal, wenn du bereit bist.",
      secure: "Sicherer PayPal-Checkout bei jeder Upgrade-Option verfügbar.",
      bestValue: "Bester Wert",
      current: "Aktuell",
      perMonth: "/ Monat",
      yearly: "Jährlich: ${price}",
      included: "Enthaltene Funktionen",
      currentPlanNote: "Du nutzt diesen Tarif",
      compareTitle: "Funktionen vergleichen",
      compareDescription: "Sieh, was jede Stufe enthält, bevor du dein Upgrade auswählst.",
      feature: "Funktion"
    },
    paypal: {
      title: "Mit PayPal bezahlen",
      description: "Sicherer Checkout mit deinem PayPal-Konto oder deiner Karte.",
      recommended: "Empfohlen",
      selectedPlan: "Ausgewählter Tarif",
      continue: "Weiter mit PayPal",
      secure: "Zahlungen werden sicher von PayPal verarbeitet."
    },
    receipt: {
      button: "Beleg PDF",
      title: "Zahlungsbeleg",
      receiptId: "Beleg-ID",
      date: "Datum",
      member: "Mitglied",
      memberFallback: "Mitglied",
      tier: "Abonnementstufe",
      cycle: "Abrechnungszyklus",
      type: "Transaktionstyp",
      provider: "Anbieter",
      status: "Status",
      total: "Gesamt bezahlt",
      thanks: "Vielen Dank für dein Abonnement."
    }
  },
  pt: {
    signInTitle: "Entre para fazer upgrade",
    signInDescription: "Entre para ver planos e continuar para o checkout PayPal.",
    signInButton: "Entrar para continuar",
    title: "💳 Cobrança e plano",
    subtitle: "Gerencie sua assinatura e método de pagamento",
    currentPlan: "Plano atual",
    currentPlanDescription: "Status e detalhes da sua assinatura",
    currentTier: "Nível atual",
    billingCycle: "Ciclo de cobrança",
    status: "Status",
    renewsOn: "Renova em",
    notAvailable: "N/D",
    readyForMore: "Pronto para mais potência?",
    upgradeToPlanForFeatures: "Faça upgrade para {plan} para recursos avançados",
    upgradeTo: "Upgrade para {plan}",
    plansTab: "📋 Planos",
    historyTab: "💰 Histórico",
    paymentTab: "🔐 Pagamento",
    billingHistory: "Histórico de cobrança",
    transactions: "{count} transações",
    noHistory: "Ainda não há histórico de cobrança",
    paymentMethod: "Método de pagamento",
    updateBillingInfo: "Atualize suas informações de cobrança",
    provider: "Provedor",
    paypalAvailable: "PayPal disponível",
    subscriptionId: "ID da assinatura",
    updatePaymentMethod: "Atualizar método de pagamento",
    viewInvoices: "Ver faturas",
    cancelPrompt: "Quer pausar ou cancelar sua assinatura?",
    cancelSubscription: "Cancelar assinatura",
    faqTitle: "❓ FAQ de cobrança",
    faqPlanQ: "Posso mudar meu plano a qualquer momento?",
    faqPlanA: "Sim, você pode fazer upgrade ou downgrade a qualquer momento. As mudanças entram em vigor imediatamente.",
    faqRefundQ: "Vocês oferecem reembolsos?",
    faqRefundA: "A elegibilidade para reembolso depende da sua conta e do provedor de pagamento. Contate o suporte para detalhes.",
    faqFailQ: "E se meu pagamento falhar?",
    faqFailA: "Vamos avisar você e tentar novamente automaticamente. Atualize seu método de pagamento para evitar interrupções.",
    pricing: {
      empty: "Os planos de assinatura ainda não estão disponíveis.",
      label: "Preços",
      title: "Escolha o plano ideal para sua rotina de navegação",
      description: "Compare níveis, revise recursos incluídos e faça upgrade com segurança pelo PayPal quando estiver pronto.",
      secure: "Checkout seguro PayPal disponível em todas as opções de upgrade.",
      bestValue: "Melhor valor",
      current: "Atual",
      perMonth: "/ mês",
      yearly: "Anual: ${price}",
      included: "Recursos incluídos",
      currentPlanNote: "Você está neste plano",
      compareTitle: "Comparar recursos",
      compareDescription: "Veja o que cada nível inclui antes de escolher seu upgrade.",
      feature: "Recurso"
    },
    paypal: {
      title: "Pagar com PayPal",
      description: "Checkout seguro usando sua conta PayPal ou cartão.",
      recommended: "Recomendado",
      selectedPlan: "Plano selecionado",
      continue: "Continuar com PayPal",
      secure: "Os pagamentos são processados com segurança pelo PayPal."
    },
    receipt: {
      button: "Recibo PDF",
      title: "Recibo de pagamento",
      receiptId: "ID do recibo",
      date: "Data",
      member: "Membro",
      memberFallback: "Membro",
      tier: "Nível da assinatura",
      cycle: "Ciclo de cobrança",
      type: "Tipo de transação",
      provider: "Provedor",
      status: "Status",
      total: "Total pago",
      thanks: "Obrigado pela sua assinatura."
    }
  },
  ar: {
    signInTitle: "سجّل الدخول للترقية",
    signInDescription: "سجّل الدخول لعرض الخطط والمتابعة إلى دفع PayPal.",
    signInButton: "تسجيل الدخول للمتابعة",
    title: "💳 الفوترة والخطة",
    subtitle: "إدارة اشتراكك وطريقة الدفع",
    currentPlan: "الخطة الحالية",
    currentPlanDescription: "حالة الاشتراك وتفاصيله",
    currentTier: "المستوى الحالي",
    billingCycle: "دورة الفوترة",
    status: "الحالة",
    renewsOn: "يتجدد في",
    notAvailable: "غير متاح",
    readyForMore: "هل أنت جاهز لمزيد من القوة؟",
    upgradeToPlanForFeatures: "قم بالترقية إلى {plan} للحصول على ميزات متقدمة",
    upgradeTo: "الترقية إلى {plan}",
    plansTab: "📋 الخطط",
    historyTab: "💰 سجل الفوترة",
    paymentTab: "🔐 طريقة الدفع",
    billingHistory: "سجل الفوترة",
    transactions: "{count} معاملات",
    noHistory: "لا يوجد سجل فوترة بعد",
    paymentMethod: "طريقة الدفع",
    updateBillingInfo: "حدّث معلومات الفوترة الخاصة بك",
    provider: "المزوّد",
    paypalAvailable: "PayPal متاح",
    subscriptionId: "معرّف الاشتراك",
    updatePaymentMethod: "تحديث طريقة الدفع",
    viewInvoices: "عرض الفواتير",
    cancelPrompt: "هل تريد إيقاف اشتراكك مؤقتاً أو إلغاءه؟",
    cancelSubscription: "إلغاء الاشتراك",
    faqTitle: "❓ أسئلة الفوترة",
    faqPlanQ: "هل يمكنني تغيير خطتي في أي وقت؟",
    faqPlanA: "نعم، يمكنك الترقية أو التخفيض في أي وقت. تسري التغييرات فوراً.",
    faqRefundQ: "هل تقدمون استرداداً؟",
    faqRefundA: "تعتمد أهلية الاسترداد على حسابك ومزوّد الدفع. تواصل مع الدعم لمزيد من التفاصيل.",
    faqFailQ: "ماذا يحدث إذا فشل الدفع؟",
    faqFailA: "سنخطرك ونعيد المحاولة تلقائياً. حدّث طريقة الدفع لتجنب الانقطاع.",
    pricing: {
      empty: "خطط الاشتراك غير متاحة بعد.",
      label: "الأسعار",
      title: "اختر الخطة المناسبة لطريقة إبحارك",
      description: "قارن مستويات الاشتراك والميزات المضمنة، ثم قم بالترقية بأمان عبر PayPal عندما تكون جاهزاً.",
      secure: "دفع PayPal آمن متاح لكل خيار ترقية.",
      bestValue: "أفضل قيمة",
      current: "الحالية",
      perMonth: "/ شهر",
      yearly: "سنوي: ${price}",
      included: "الميزات المضمنة",
      currentPlanNote: "أنت على هذه الخطة",
      compareTitle: "مقارنة الميزات",
      compareDescription: "اطلع على ما يتضمنه كل مستوى قبل اختيار الترقية.",
      feature: "الميزة"
    },
    paypal: {
      title: "الدفع عبر PayPal",
      description: "دفع آمن باستخدام حساب PayPal أو البطاقة.",
      recommended: "موصى به",
      selectedPlan: "الخطة المحددة",
      continue: "المتابعة مع PayPal",
      secure: "تتم معالجة المدفوعات بأمان عبر PayPal."
    },
    receipt: {
      button: "إيصال PDF",
      title: "إيصال الدفع",
      receiptId: "معرّف الإيصال",
      date: "التاريخ",
      member: "العضو",
      memberFallback: "العضو",
      tier: "مستوى الاشتراك",
      cycle: "دورة الفوترة",
      type: "نوع المعاملة",
      provider: "المزوّد",
      status: "الحالة",
      total: "الإجمالي المدفوع",
      thanks: "شكراً لاشتراكك."
    }
  },
  el: {
    signInTitle: "Συνδεθείτε για αναβάθμιση",
    signInDescription: "Συνδεθείτε για να δείτε τα πακέτα και να συνεχίσετε στο PayPal.",
    signInButton: "Σύνδεση για συνέχεια",
    title: "💳 Χρέωση και πακέτο",
    subtitle: "Διαχειριστείτε τη συνδρομή και τον τρόπο πληρωμής σας",
    currentPlan: "Τρέχον πακέτο",
    currentPlanDescription: "Κατάσταση και λεπτομέρειες συνδρομής",
    currentTier: "Τρέχον επίπεδο",
    billingCycle: "Κύκλος χρέωσης",
    status: "Κατάσταση",
    renewsOn: "Ανανεώνεται στις",
    notAvailable: "Μ/Δ",
    readyForMore: "Έτοιμοι για περισσότερη ισχύ;",
    upgradeToPlanForFeatures: "Αναβαθμίστε σε {plan} για προηγμένες λειτουργίες",
    upgradeTo: "Αναβάθμιση σε {plan}",
    plansTab: "📋 Πακέτα",
    historyTab: "💰 Ιστορικό",
    paymentTab: "🔐 Πληρωμή",
    billingHistory: "Ιστορικό χρεώσεων",
    transactions: "{count} συναλλαγές",
    noHistory: "Δεν υπάρχει ακόμη ιστορικό χρεώσεων",
    paymentMethod: "Τρόπος πληρωμής",
    updateBillingInfo: "Ενημερώστε τα στοιχεία χρέωσης",
    provider: "Πάροχος",
    paypalAvailable: "PayPal διαθέσιμο",
    subscriptionId: "ID συνδρομής",
    updatePaymentMethod: "Ενημέρωση τρόπου πληρωμής",
    viewInvoices: "Προβολή τιμολογίων",
    cancelPrompt: "Θέλετε να παύσετε ή να ακυρώσετε τη συνδρομή;",
    cancelSubscription: "Ακύρωση συνδρομής",
    faqTitle: "❓ Συχνές ερωτήσεις χρέωσης",
    faqPlanQ: "Μπορώ να αλλάξω πακέτο οποιαδήποτε στιγμή;",
    faqPlanA: "Ναι, μπορείτε να αναβαθμίσετε ή να υποβαθμίσετε οποιαδήποτε στιγμή. Οι αλλαγές ισχύουν άμεσα.",
    faqRefundQ: "Προσφέρετε επιστροφές χρημάτων;",
    faqRefundA: "Η δυνατότητα επιστροφής εξαρτάται από τον λογαριασμό σας και τον πάροχο πληρωμών. Επικοινωνήστε με την υποστήριξη για λεπτομέρειες.",
    faqFailQ: "Τι γίνεται αν αποτύχει η πληρωμή;",
    faqFailA: "Θα σας ειδοποιήσουμε και θα δοκιμάσουμε ξανά αυτόματα. Ενημερώστε τον τρόπο πληρωμής για να αποφύγετε διακοπές.",
    pricing: {
      empty: "Τα πακέτα συνδρομής δεν είναι ακόμη διαθέσιμα.",
      label: "Τιμολόγηση",
      title: "Επιλέξτε το πακέτο που ταιριάζει στη ναυτική σας ροή",
      description: "Συγκρίνετε επίπεδα, δείτε τις λειτουργίες και αναβαθμίστε με ασφάλεια μέσω PayPal όταν είστε έτοιμοι.",
      secure: "Ασφαλές checkout PayPal διαθέσιμο σε κάθε επιλογή αναβάθμισης.",
      bestValue: "Καλύτερη αξία",
      current: "Τρέχον",
      perMonth: "/ μήνα",
      yearly: "Ετήσιο: ${price}",
      included: "Περιλαμβανόμενες λειτουργίες",
      currentPlanNote: "Βρίσκεστε σε αυτό το πακέτο",
      compareTitle: "Σύγκριση λειτουργιών",
      compareDescription: "Δείτε τι περιλαμβάνει κάθε επίπεδο πριν επιλέξετε αναβάθμιση.",
      feature: "Λειτουργία"
    },
    paypal: {
      title: "Πληρωμή με PayPal",
      description: "Ασφαλής πληρωμή με λογαριασμό PayPal ή κάρτα.",
      recommended: "Προτεινόμενο",
      selectedPlan: "Επιλεγμένο πακέτο",
      continue: "Συνέχεια με PayPal",
      secure: "Οι πληρωμές διεκπεραιώνονται με ασφάλεια από το PayPal."
    },
    receipt: {
      button: "Απόδειξη PDF",
      title: "Απόδειξη πληρωμής",
      receiptId: "ID απόδειξης",
      date: "Ημερομηνία",
      member: "Μέλος",
      memberFallback: "Μέλος",
      tier: "Επίπεδο συνδρομής",
      cycle: "Κύκλος χρέωσης",
      type: "Τύπος συναλλαγής",
      provider: "Πάροχος",
      status: "Κατάσταση",
      total: "Σύνολο πληρωμής",
      thanks: "Ευχαριστούμε για τη συνδρομή σας."
    }
  },
  ru: {
    signInTitle: "Войдите, чтобы обновить план",
    signInDescription: "Войдите, чтобы посмотреть планы и перейти к оплате через PayPal.",
    signInButton: "Войти и продолжить",
    title: "💳 Оплата и план",
    subtitle: "Управляйте подпиской и способом оплаты",
    currentPlan: "Текущий план",
    currentPlanDescription: "Статус и детали вашей подписки",
    currentTier: "Текущий уровень",
    billingCycle: "Период оплаты",
    status: "Статус",
    renewsOn: "Продлевается",
    notAvailable: "Н/Д",
    readyForMore: "Готовы к большему?",
    upgradeToPlanForFeatures: "Перейдите на {plan}, чтобы получить расширенные функции",
    upgradeTo: "Перейти на {plan}",
    plansTab: "📋 Планы",
    historyTab: "💰 История",
    paymentTab: "🔐 Способ оплаты",
    billingHistory: "История оплат",
    transactions: "{count} транзакций",
    noHistory: "Истории оплат пока нет",
    paymentMethod: "Способ оплаты",
    updateBillingInfo: "Обновите платежную информацию",
    provider: "Провайдер",
    paypalAvailable: "PayPal доступен",
    subscriptionId: "ID подписки",
    updatePaymentMethod: "Обновить способ оплаты",
    viewInvoices: "Посмотреть счета",
    cancelPrompt: "Хотите приостановить или отменить подписку?",
    cancelSubscription: "Отменить подписку",
    faqTitle: "❓ Вопросы по оплате",
    faqPlanQ: "Можно ли изменить план в любое время?",
    faqPlanA: "Да, вы можете повысить или понизить план в любое время. Изменения вступают в силу сразу.",
    faqRefundQ: "Вы делаете возвраты?",
    faqRefundA: "Право на возврат зависит от вашего аккаунта и платежного провайдера. Свяжитесь с поддержкой для подробностей.",
    faqFailQ: "Что если платеж не пройдет?",
    faqFailA: "Мы уведомим вас и повторим попытку автоматически. Обновите способ оплаты, чтобы избежать перерывов.",
    pricing: {
      empty: "Планы подписки пока недоступны.",
      label: "Цены",
      title: "Выберите план для вашего стиля навигации",
      description: "Сравните уровни подписки, проверьте включенные функции и безопасно обновитесь через PayPal.",
      secure: "Безопасная оплата PayPal доступна для каждого варианта обновления.",
      bestValue: "Лучшее предложение",
      current: "Текущий",
      perMonth: "/ месяц",
      yearly: "Годовой: ${price}",
      included: "Включенные функции",
      currentPlanNote: "Вы используете этот план",
      compareTitle: "Сравнить функции",
      compareDescription: "Посмотрите, что входит в каждый уровень, перед выбором обновления.",
      feature: "Функция"
    },
    paypal: {
      title: "Оплатить через PayPal",
      description: "Безопасная оплата через аккаунт PayPal или карту.",
      recommended: "Рекомендуется",
      selectedPlan: "Выбранный план",
      continue: "Продолжить с PayPal",
      secure: "Платежи безопасно обрабатываются PayPal."
    },
    receipt: {
      button: "Чек PDF",
      title: "Платежный чек",
      receiptId: "ID чека",
      date: "Дата",
      member: "Участник",
      memberFallback: "Участник",
      tier: "Уровень подписки",
      cycle: "Период оплаты",
      type: "Тип транзакции",
      provider: "Провайдер",
      status: "Статус",
      total: "Всего оплачено",
      thanks: "Спасибо за вашу подписку."
    }
  },
  tr: {
    signInTitle: "Yükseltmek için giriş yapın",
    signInDescription: "Planları görmek ve PayPal ödeme sayfasına devam etmek için giriş yapın.",
    signInButton: "Devam etmek için giriş yap",
    title: "💳 Faturalandırma ve plan",
    subtitle: "Aboneliğinizi ve ödeme yönteminizi yönetin",
    currentPlan: "Mevcut plan",
    currentPlanDescription: "Abonelik durumunuz ve detayları",
    currentTier: "Mevcut seviye",
    billingCycle: "Fatura dönemi",
    status: "Durum",
    renewsOn: "Yenilenme tarihi",
    notAvailable: "Yok",
    readyForMore: "Daha fazla güç için hazır mısınız?",
    upgradeToPlanForFeatures: "Gelişmiş özellikler için {plan} planına yükseltin",
    upgradeTo: "{plan} planına yükselt",
    plansTab: "📋 Planlar",
    historyTab: "💰 Fatura geçmişi",
    paymentTab: "🔐 Ödeme yöntemi",
    billingHistory: "Fatura geçmişi",
    transactions: "{count} işlem",
    noHistory: "Henüz fatura geçmişi yok",
    paymentMethod: "Ödeme yöntemi",
    updateBillingInfo: "Fatura bilgilerinizi güncelleyin",
    provider: "Sağlayıcı",
    paypalAvailable: "PayPal kullanılabilir",
    subscriptionId: "Abonelik ID",
    updatePaymentMethod: "Ödeme yöntemini güncelle",
    viewInvoices: "Faturaları görüntüle",
    cancelPrompt: "Aboneliğinizi duraklatmak veya iptal etmek ister misiniz?",
    cancelSubscription: "Aboneliği iptal et",
    faqTitle: "❓ Faturalandırma SSS",
    faqPlanQ: "Planımı istediğim zaman değiştirebilir miyim?",
    faqPlanA: "Evet, istediğiniz zaman yükseltebilir veya düşürebilirsiniz. Değişiklikler hemen geçerli olur.",
    faqRefundQ: "İade sunuyor musunuz?",
    faqRefundA: "İade uygunluğu hesabınıza ve ödeme sağlayıcınıza bağlıdır. Detaylar için destekle iletişime geçin.",
    faqFailQ: "Ödemem başarısız olursa ne olur?",
    faqFailA: "Sizi bilgilendirir ve otomatik olarak tekrar deneriz. Kesinti yaşamamak için ödeme yönteminizi güncelleyin.",
    pricing: {
      empty: "Abonelik planları henüz mevcut değil.",
      label: "Fiyatlandırma",
      title: "Yelken iş akışınıza uygun planı seçin",
      description: "Abonelik seviyelerini karşılaştırın, dahil özellikleri inceleyin ve hazır olduğunuzda PayPal ile güvenle yükseltin.",
      secure: "Her yükseltme seçeneğinde güvenli PayPal ödemesi mevcuttur.",
      bestValue: "En iyi değer",
      current: "Mevcut",
      perMonth: "/ ay",
      yearly: "Yıllık: ${price}",
      included: "Dahil özellikler",
      currentPlanNote: "Bu plandasınız",
      compareTitle: "Özellikleri karşılaştır",
      compareDescription: "Yükseltmenizi seçmeden önce her seviyenin neler içerdiğini görün.",
      feature: "Özellik"
    },
    paypal: {
      title: "PayPal ile öde",
      description: "PayPal hesabınız veya kartınızla güvenli ödeme.",
      recommended: "Önerilir",
      selectedPlan: "Seçilen plan",
      continue: "PayPal ile devam et",
      secure: "Ödemeler PayPal tarafından güvenli şekilde işlenir."
    },
    receipt: {
      button: "Makbuz PDF",
      title: "Ödeme makbuzu",
      receiptId: "Makbuz ID",
      date: "Tarih",
      member: "Üye",
      memberFallback: "Üye",
      tier: "Abonelik seviyesi",
      cycle: "Fatura dönemi",
      type: "İşlem türü",
      provider: "Sağlayıcı",
      status: "Durum",
      total: "Toplam ödenen",
      thanks: "Aboneliğiniz için teşekkür ederiz."
    }
  },
  zh: {
    signInTitle: "登录以升级",
    signInDescription: "登录以查看方案并继续 PayPal 付款。",
    signInButton: "登录并继续",
    title: "💳 账单与方案",
    subtitle: "管理你的订阅和付款方式",
    currentPlan: "当前方案",
    currentPlanDescription: "你的订阅状态和详情",
    currentTier: "当前等级",
    billingCycle: "计费周期",
    status: "状态",
    renewsOn: "续订日期",
    notAvailable: "不可用",
    readyForMore: "准备获得更多能力？",
    upgradeToPlanForFeatures: "升级到 {plan} 以获得高级功能",
    upgradeTo: "升级到 {plan}",
    plansTab: "📋 方案",
    historyTab: "💰 账单历史",
    paymentTab: "🔐 付款方式",
    billingHistory: "账单历史",
    transactions: "{count} 笔交易",
    noHistory: "暂无账单历史",
    paymentMethod: "付款方式",
    updateBillingInfo: "更新你的账单信息",
    provider: "服务商",
    paypalAvailable: "PayPal 可用",
    subscriptionId: "订阅 ID",
    updatePaymentMethod: "更新付款方式",
    viewInvoices: "查看发票",
    cancelPrompt: "想暂停或取消订阅吗？",
    cancelSubscription: "取消订阅",
    faqTitle: "❓ 账单常见问题",
    faqPlanQ: "我可以随时更改方案吗？",
    faqPlanA: "可以，你可以随时升级或降级。更改会立即生效。",
    faqRefundQ: "你们提供退款吗？",
    faqRefundA: "退款资格取决于你的账户和付款服务商。请联系支持获取详情。",
    faqFailQ: "如果付款失败怎么办？",
    faqFailA: "我们会通知你并自动重试。请更新付款方式以避免中断。",
    pricing: {
      empty: "订阅方案尚不可用。",
      label: "价格",
      title: "选择适合你航海流程的方案",
      description: "比较订阅等级，查看包含的功能，准备好后通过 PayPal 安全升级。",
      secure: "每个升级选项都支持安全 PayPal 付款。",
      bestValue: "最优价值",
      current: "当前",
      perMonth: "/ 月",
      yearly: "年度：${price}",
      included: "包含功能",
      currentPlanNote: "你正在使用此方案",
      compareTitle: "比较功能",
      compareDescription: "选择升级前，查看每个等级包含的内容。",
      feature: "功能"
    },
    paypal: {
      title: "使用 PayPal 付款",
      description: "使用 PayPal 账户或银行卡安全结账。",
      recommended: "推荐",
      selectedPlan: "已选方案",
      continue: "继续使用 PayPal",
      secure: "付款由 PayPal 安全处理。"
    },
    receipt: {
      button: "PDF 收据",
      title: "付款收据",
      receiptId: "收据 ID",
      date: "日期",
      member: "会员",
      memberFallback: "会员",
      tier: "订阅等级",
      cycle: "计费周期",
      type: "交易类型",
      provider: "服务商",
      status: "状态",
      total: "已支付总额",
      thanks: "感谢你的订阅。"
    }
  }
};

billingTranslations.default = billingTranslations.en;

export function getBillingTranslations(language = "en") {
  return billingTranslations[language] || billingTranslations.en;
}

export const planTranslations = {
  en: {
    basic: { name: "Free", description: "Basic weather, learning resources, public marina discovery, and sailing calculators." },
    premium: { name: "Premium", description: "Personalized skipper briefings, route and weather risk awareness, saved-area intelligence, and advanced decision support." },
    advanced: { name: "Premium", description: "Personalized skipper briefings, route and weather risk awareness, saved-area intelligence, and advanced decision support." },
    professional: { name: "Premium", description: "Personalized skipper briefings, route and weather risk awareness, saved-area intelligence, and advanced decision support." },
    enterprise: { name: "Premium", description: "Personalized skipper briefings, route and weather risk awareness, saved-area intelligence, and advanced decision support." }
  },
  he: {
    basic: { name: "חוקר", description: "מושלם להתחלה ולהיכרות עם הפלטפורמה." },
    advanced: { name: "מתכנן", description: "לסקיפרים פעילים שמארגנים הפלגות באופן קבוע" },
    professional: { name: "סקיפר מקצועי", description: "לסקיפרים מסחריים, מפעילי צ׳רטר ומשתמשים מתקדמים" }
  },
  es: {
    basic: { name: "Explorador", description: "Perfecto para empezar y descubrir la plataforma." },
    advanced: { name: "Planificador", description: "Para patrones activos que organizan viajes con regularidad" },
    professional: { name: "Patrón profesional", description: "Para patrones comerciales, operadores de chárter y usuarios avanzados" }
  },
  it: {
    basic: { name: "Esploratore", description: "Perfetto per iniziare e scoprire la piattaforma." },
    advanced: { name: "Pianificatore", description: "Per skipper attivi che organizzano viaggi regolarmente" },
    professional: { name: "Skipper professionale", description: "Per skipper commerciali, operatori charter e utenti avanzati" }
  },
  fr: {
    basic: { name: "Explorateur", description: "Parfait pour commencer et découvrir la plateforme." },
    advanced: { name: "Planificateur", description: "Pour les skippers actifs qui organisent régulièrement des sorties" },
    professional: { name: "Skipper professionnel", description: "Pour les skippers commerciaux, opérateurs de charter et utilisateurs avancés" }
  },
  de: {
    basic: { name: "Entdecker", description: "Perfekt, um zu starten und die Plattform kennenzulernen." },
    advanced: { name: "Planer", description: "Für aktive Skipper, die regelmäßig Törns organisieren" },
    professional: { name: "Professioneller Skipper", description: "Für gewerbliche Skipper, Charteranbieter und fortgeschrittene Nutzer" }
  },
  pt: {
    basic: { name: "Explorador", description: "Perfeito para começar e descobrir a plataforma." },
    advanced: { name: "Planejador", description: "Para skippers ativos que organizam viagens regularmente" },
    professional: { name: "Skipper profissional", description: "Para skippers comerciais, operadores de charter e usuários avançados" }
  },
  ar: {
    basic: { name: "المستكشف", description: "مثالي للبدء واكتشاف المنصة." },
    advanced: { name: "المخطط", description: "للربابنة النشطين الذين ينظمون الرحلات بانتظام" },
    professional: { name: "ربان محترف", description: "للربابنة التجاريين ومشغلي التأجير والمستخدمين المتقدمين" }
  },
  el: {
    basic: { name: "Εξερευνητής", description: "Ιδανικό για να ξεκινήσετε και να γνωρίσετε την πλατφόρμα." },
    advanced: { name: "Σχεδιαστής", description: "Για ενεργούς κυβερνήτες που οργανώνουν τακτικά ταξίδια" },
    professional: { name: "Επαγγελματίας κυβερνήτης", description: "Για εμπορικούς κυβερνήτες, εταιρείες charter και προχωρημένους χρήστες" }
  },
  ru: {
    basic: { name: "Исследователь", description: "Идеально для начала работы и знакомства с платформой." },
    advanced: { name: "Планировщик", description: "Для активных шкиперов, которые регулярно организуют поездки" },
    professional: { name: "Профессиональный шкипер", description: "Для коммерческих шкиперов, чартерных операторов и опытных пользователей" }
  },
  tr: {
    basic: { name: "Kaşif", description: "Başlamak ve platformu keşfetmek için mükemmel." },
    advanced: { name: "Planlayıcı", description: "Düzenli seyahat organize eden aktif kaptanlar için" },
    professional: { name: "Profesyonel kaptan", description: "Ticari kaptanlar, charter operatörleri ve ileri kullanıcılar için" }
  },
  zh: {
    basic: { name: "探索者", description: "非常适合开始使用并了解平台。" },
    advanced: { name: "规划者", description: "适合经常组织航行的活跃船长" },
    professional: { name: "专业船长", description: "适合商业船长、包船运营商和高级用户" }
  }
};

export function localizeSubscriptionPlan(plan, language = "en") {
  if (!plan) return plan;
  const localized = planTranslations[language]?.[plan.tier] || planTranslations.en?.[plan.tier];
  if (!localized) return plan;
  return {
    ...plan,
    name: localized.name || plan.name,
    description: localized.description || plan.description
  };
}